<template lang="html">
  <div class="conversion-coupon" v-if="couponInfo">
    <h1>- 您有{{couponInfo.value}}元代金券未使用 -</h1>
    <div class="coupon" @click="$router.push('/preferential')">
      <div class="coupon-desc">
        <h3>{{couponInfo.value}}<span>元代金券</span></h3>
        <p>有效期至: {{endTime}}</p>
        <p>已存入微课账号·全场通用 </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConversionCoupon',
  props: ['couponInfo', 'useEnd'],
  computed: {
    endTime () {
      if (this.useEnd) {
        let endTime = new Date(this.useEnd)
        return  moment(endTime).format('YYYY-MM-DD HH:mm')
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.conversion-coupon {
  margin-bottom: rem(55);
  padding-top: rem(25);
  h1 {
    color: #666666;
    font-size: rem(24);
    text-align: center;
    margin-bottom: rem(25);
  }
  .coupon {
    width: rem(680);
    height: rem(233);
    margin: auto;
    background-image: url("./images/coupon.png");
    background-size: 100% 100%;
    position: relative;
    box-shadow: rgba(#2E3748, .21) rem(0) rem(12) rem(14) rem(0);
    border-radius: rem(20);
    img {
      width: 100%;
    }
    &-desc {
      position: absolute;
      left: rem(60);
      top: rem(30);
      h3 {
        font-size: rem(80);
        color: #F48F00;
        margin-bottom: rem(20);
        > span {
          font-size: rem(36);
        }
      }
      p {
        line-height: 1.2;
        color: #A08561;
        font-size: rem(22);
      }
    }
  }
}
</style>
